import React from 'react';
import PropTypes from 'prop-types';
import DatepickerComponent from "core/gd-components/datetime/datepicker/datepicker";
import DaterangePicker from "core/gd-components/datetime/gd-daterange-picker/daterange-picker";

export default class FilterFormDate extends React.Component {

    static propTypes = {
        filter: PropTypes.object.isRequired,         // link to filter instance
    };


    constructor(props) {
        super(props);
    }


    // onOptionClick = (newOption) => {
    //
    //     // const curValue = this.props.filter.getValue();
    //     // let newValue;
    //     //
    //     // if (this.props.filter.isEnabled) {
    //     //     // multiselct mode
    //     //     newValue = gd.utils.toggleArrayValue(curValue, value);
    //     // } else {
    //     //     // select one mode
    //     //     newValue = [value];
    //     // }
    //     //
    //     // if (newValue.length >= this.props.minItemsSelected) {
    //     //     this.props.filter.setValue(newValue, false);
    //     //     this.setState({reRender: true});
    //     // }
    //
    //     const curValue = this.props.filter.getValue();
    //     let newValue;
    //
    //     if (!curValue.value) {
    //         newValue = Moment();
    //     } else {
    //         newValue = curValue.value;
    //     }
    //
    //     switch (newOption) {
    //
    //         case 'is-before':
    //             break;
    //
    //         case 'is-after':
    //             break;
    //
    //         case 'range':
    //             break;
    //     }
    //
    //     this.props.filter.setValue({
    //         noDate: curValue.noDate,
    //         curOption: newOption,
    //         value: newValue
    //     }, false);
    //
    //     this.setState({reRender: true});
    // };

    onNoDateClick = () => {
        const curValue = this.props.filter.getValue();
        curValue.noDate = !curValue.noDate;
        this.props.filter.setValue(curValue, false);
        this.setState({reRender: true});

    };

    setIsBefore = (date) => {

        const curValue = this.props.filter.getValue();

        if (Moment.isMoment(date)) {
            // do nothing
        } else {
            date = Moment();
            if (Moment.isMoment(curValue.date)) {
                date = curValue.date
            }
        }

        this.props.filter.setValue({
            noDate: curValue.noDate,
            curOption: 'is-before',
            date: date,
        }, false);

        this.setState({reRender: true});
    };

    setIsAfter = (date) => {
        const curValue = this.props.filter.getValue();

        if (Moment.isMoment(date)) {
            // do nothing
        } else {
            date = Moment();
            if (Moment.isMoment(curValue.date)) {
                date = curValue.date
            }
        }

        this.props.filter.setValue({
            noDate: curValue.noDate,
            curOption: 'is-after',
            date: date,
        }, false);

        this.setState({reRender: true});
    };

    setRange = (dateRange) => {
        const curValue = this.props.filter.getValue();

        if (dateRange && dateRange.start) {
            // do nothing
        } else {
            dateRange = Moment.range(Moment().subtract(2,'weeks'), Moment().add(1,'month'));
        }

        curValue.curOption = 'range';
        curValue.date = dateRange;

        this.props.filter.setValue(curValue, false);

        this.setState({reRender: true});
    };

    render() {

        const curValue = this.props.filter.getValue();
        const {curOption, value, noDate} = curValue;

        return (
            <div className="block-content filter-multiselect">

                {this.props.filter.showNoDateOption &&
                <div className={Classes("type-option")} onClick={this.onNoDateClick}>
                    <div className={Classes('gd-cb-12',{selected: noDate})}> </div>

                    <div className="name">
                        {this.props.filter.noDateLabel}
                    </div>
                    <div className="cf"> </div>
                </div>}

                <div className={Classes("type-option")} onClick={this.setIsBefore}>
                    <div className={Classes('gd-radio',{selected: (curOption=='is-before') })}> </div>
                    <div className="name">
                        Is before
                    </div>
                    {curOption=='is-before' && <DatepickerComponent skin="form" value={curValue.date} formSize={30} onSelect={this.setIsBefore} markPastdue={false} />}
                    <div className="cf"> </div>
                </div>

                <div className={Classes("type-option")} onClick={this.setIsAfter}>
                    <div className={Classes('gd-radio',{selected: (curOption=='is-after') })}> </div>
                    <div className="name">Is After</div>
                    {curOption=='is-after' && <DatepickerComponent skin="form" value={curValue.date} formSize={30} onSelect={this.setIsAfter} markPastdue={false} />}
                    <div className="cf"> </div>
                </div>

                <div className={Classes("type-option")} onClick={this.setRange}>
                    <div className={Classes('gd-radio',{selected: (curOption=='range') })}> </div>
                    <div className="name">Date range</div>
                    {curOption=='range' && <DaterangePicker skin="form" value={curValue.date} formSize={30} onUserSelect={this.setRange} markPastdue={false} />}
                    <div className="cf"> </div>
                </div>

            </div>
        );
    }
}